// extracted by mini-css-extract-plugin
module.exports = {"section":"Section7_section__2OfyZ","text1":"Section7_text1__nyxOX","text2":"Section7_text2__m__Er","header":"Section7_header__3OxPC","textHeader":"Section7_textHeader__1p3x9"};